import { createContext, useContext } from 'react';
import { useRealtimeScheduleShiftManager, RealtimeScheduleShiftManagerOptions } from '../lib/supabase/schedule-shifts/realtimeScheduleShiftManager';

interface RealtimeScheduleShiftContextType {
  isConnected: boolean;
}

const RealtimeScheduleShiftContext = createContext<RealtimeScheduleShiftContextType | undefined>(undefined);

interface RealtimeScheduleShiftProviderProps extends RealtimeScheduleShiftManagerOptions {
  children: React.ReactNode;
}

export function RealtimeScheduleShiftProvider({ children, ...options }: RealtimeScheduleShiftProviderProps) {
  const { isConnected } = useRealtimeScheduleShiftManager(options);

  return (
    <RealtimeScheduleShiftContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeScheduleShiftContext.Provider>
  );
}

export function useRealtimeScheduleShift() {
  const context = useContext(RealtimeScheduleShiftContext);
  if (context === undefined) {
    throw new Error('useRealtimeScheduleShift must be used within a RealtimeScheduleShiftProvider');
  }
  return context;
}